import { required } from 'vuelidate/lib/validators'
import formValidator from '@/mixins/form-validator.js'
import axios from 'axios'
import toastStore from '@/stores/toast-store.js'
import CurrentUserResolver from '@/mixins/current-user-resolver.js'
import parentRoute from '@/mixins/parent-route.js'
import sessionStore from '@/stores/session-store.js'

export default {
  name: 'ProfileName',
  mixins: [formValidator, CurrentUserResolver, parentRoute],
  data: function () {
    return {
      errors: {},
      submitted: false,

      user: {
        name: '',
      },

      blocker: false,
      validatedItemKey: 'user',
    }
  },
  watch: {
    currentUser: {
      handler: function () {
        this.user.name = this.currentUser.name
      },
      deep: true,
    },
  },
  computed: {
    inputValuesChanged() {
      return this.user.name != this.currentUser.name
    },
  },
  methods: {
    save: function (e) {
      e.preventDefault()
      this.submitted = true
      this.validateForm()

      if (Object.keys(this.errors).length > 0) {
        toastStore.commit('error', {
          message: this.$t('messages.validationErrorFillFields'),
        })
      } else {
        this.blocker = true
        axios({
          method: 'put',
          url: `users/${this.currentUser.id}`,
          data: {
            user: {
              name: this.user.name,
            },
          },
        })
          .then(response => {
            sessionStore.commit('setUser', response.data)
            this.blocker = false
            this.$router.go(-1)
          })
          .catch(error => {
            this.blocker = false
            let errorMessage = !!error.response.data.errors
              ? Object.values(error.response.data.errors).join(', ')
              : this.$t('messages.error')
            toastStore.commit('error', { message: errorMessage })
            console.error('error save', error.response)
          })
      }
    },
  },
  validations() {
    if (this.submitted) {
      return {
        user: {
          name: {
            required,
          },
        },
      }
    } else {
      return {}
    }
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
